import { render, staticRenderFns } from "./simple-report-with-pagination.vue?vue&type=template&id=5a3f8950"
import script from "./simple-report-with-pagination.vue?vue&type=script&lang=js"
export * from "./simple-report-with-pagination.vue?vue&type=script&lang=js"
import style0 from "./simple-report-with-pagination.vue?vue&type=style&index=0&id=5a3f8950&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports